import axios from 'axios'
import { collection, doc, getDocs, setDoc, updateDoc } from 'firebase/firestore'
import { BASE_FIREBASE_FUNCTIONS_URL } from 'src/utils/config/config'
import { getSession } from 'src/utils/functions/localStorage'
import { db, fetchFirebaseData } from '../firebase-compat'

// Adding temporary change [need to used the serviceClient variable]
export interface Route {
  key: string
  label: string
}

export interface Routes extends Route {
  subNav: Route
}

export async function verifyUser({ email }: { email: string }) {
  return await axios.post(`${BASE_FIREBASE_FUNCTIONS_URL}/verify_user`, { email })
} // Adding temporary change [need to used the serviceClient variable]

export async function getAll(table: string): Promise<any[]> {
  try {
    const data = await fetchFirebaseData(table)
    return data
  } catch (error) {
    throw error
  }
}
export async function getAllFirebase(table: string): Promise<any> {
  try {
    const data = await getDocs(collection(db, table))
    const result = []
    data.forEach((item) => result.push({ ...item.data(), id: item.id }))
    return result
  } catch (error) {
    throw error
  }
}

export async function get(table: string, id: string): Promise<{ [key: string]: string }> {
  try {
    const data = await fetchFirebaseData(table, id)
    return data
  } catch (error) {
    throw error
  }
}

export const getDateAndUser = (status: 'create' | 'update') => {
  const date = new Date().toUTCString()
  const currentUser = getSession('data')
  const user = currentUser?.email
  return status === 'create' ? { created_at: date, created_by: user } : { updated_at: date, updated_by: user }
}

export async function updateDocument(table: string, uid: string, values: any) {
  const docRef = doc(db, table, uid)
  return await updateDoc(docRef, { ...values, ...getDateAndUser('update') })
}

export async function createDocument(table: string, uid: string, values: any) {
  const docRef = doc(db, table, uid)
  return await setDoc(docRef, { ...values, ...getDateAndUser('create') })
}
